import { AccessUserTypes } from 'apps-common/types';

export const userTypeIsAllowed = (userAccesses: AccessUserTypes[], userType: AccessUserTypes) => {
  return userAccesses.some((allowedType) =>
    allowedType.endsWith('_ALL') ? userType.startsWith(allowedType.slice(0, -4)) : userType === allowedType,
  );
};
